var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircle = function SvgCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 9.875c0 5.27-4.268 9.5-9.5 9.5a9.47 9.47 0 0 1-9.5-9.5c0-5.232 4.23-9.5 9.5-9.5 5.232 0 9.5 4.268 9.5 9.5M10 2.156c-4.268 0-7.719 3.489-7.719 7.719A7.713 7.713 0 0 0 10 17.594c4.23 0 7.719-3.451 7.719-7.719 0-4.23-3.489-7.719-7.719-7.719"
  })));
};
export default SvgCircle;